import CTAGradient from './CTAGradient';
import SimpleJustified from './SimpleJustified';
import Big from './Big';
import BigEasyTag from './BigEasyTag';

export default { CTAGradient, SimpleJustified, Big, BigEasyTag };
